import { Injectable, EventEmitter } from '@angular/core';
import {Subject, Observable} from 'rxjs';

import {ApiService} from './api.service';
import {User} from './user.model';
    
@Injectable()
export class UserService {
    user = new Subject<any>();
    users = [];
    usersAdded = new EventEmitter();

    constructor(private api: ApiService) {
        this.user.subscribe(user => {
            this.loadUsers();
        });
        const currentUserId = this.api.getProp('currentUserId');
        let user = this.api.getProp('user');
        if( currentUserId ) {
            setTimeout(() => {
               user = new User(user);
                this.user.next(user);
            });
        }
    }
    loadUsers() {
        const usersAddedSubscription = this.usersAdded.subscribe(page => {
            if( this.api.getProp('foundPosts') > (page * 100) ) {
                this.setUsersFromApi(page+1);
            } else {
                usersAddedSubscription.unsubscribe();  
            }
        });
        this.setUsersFromApi(1);
    }
    getUsers() {
        return this.users;
    }
    getUser(userId) {
        let user = false;
        if( this.users.length > 0 ) {
            let found = this.users.filter(user => {
                return user.id == userId; 
            });
            if( found.length > 0 ) {
                return found[0];
            }
        }
        return user;
    }
    getCurrentUser() {
        return this.user;
    }
    setCurrentUser(userData) {
        if( !userData.id ) {
            this.api.setProp('currentUserId', 0);
            return;
        }
        let user = this.getUser(userData.id);
        if( user ) {
            this.user.next(user);
            this.api.setProp('user', user);
            this.api.setProp('currentUserId', user.id);
        } else {
            // fallback to api
            this.setCurrentUserFromApi(userData.localId);
        }
    }
    setUsersFromApi(page) {
        this.api.doAction('post', 'users', {
            action: 'get_users',
            page: page,
            per_page: 100
        }).subscribe(
            users => {
                const userIds = this.users.map(item => item.id);
                for(var i = 0; i < users.length; i++) {
                    const user = new User(users[i]);
                    if( userIds.indexOf(user.id) === -1 ) {
                        this.users.push(user);
                    }
                }
                this.usersAdded.emit(page);
            }
        );
    }
    setCurrentUserFromApi(localId) {
        this.api.doAction('post', 'users', {
            localId: localId,
            action: 'get_user'
        }).subscribe(
            data => {
                let user = new User(data);
                this.user.next(user);
                this.api.setProp('user', user);
                this.api.setProp('currentUserId', user.id);
            }
        );
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/shared/user.service.ts